/* WeddingInvites.pk — premium interactions */
(function () {
  var doc = document.documentElement;
  doc.classList.add('wi-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    /* ---- Reveal on scroll ---- */
    var revealEls = [].slice.call(document.querySelectorAll('[data-wi-reveal], .wi-lines'));
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
    }
    // Safety net: never leave content hidden
    setTimeout(function () { revealEls.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight) el.classList.add('is-in'); }); }, 2500);

    /* ---- Header ---- */
    var header = document.querySelector('[data-wi-header]');
    if (header && header.classList.contains('wi-header--overlay')) {
      var onScroll = function () { header.classList.toggle('is-solid', window.scrollY > 40); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('load', onScroll);
      window.addEventListener('hashchange', function () { setTimeout(onScroll, 50); });
      setTimeout(onScroll, 300);
    }
    var drawer = document.querySelector('[data-wi-drawer]');
    document.querySelectorAll('[data-wi-drawer-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!drawer) return;
        var open = !drawer.classList.contains('is-open');
        drawer.classList.toggle('is-open', open);
        document.body.style.overflow = open ? 'hidden' : '';
        b.setAttribute('aria-expanded', open);
      });
    });
    if (drawer) drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { drawer.classList.remove('is-open'); document.body.style.overflow = ''; });
    });

    /* ---- Gold dust canvas (hero) ---- */
    document.querySelectorAll('[data-wi-dust]').forEach(function (canvas) {
      if (reduce) return;
      var ctx = canvas.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2), W, H, parts = [], running = true;
      function size() {
        W = canvas.offsetWidth; H = canvas.offsetHeight; canvas.width = W * dpr; canvas.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var n = Math.round(Math.min(90, W * H / 14000)); parts = [];
        for (var i = 0; i < n; i++) parts.push({ x: Math.random() * W, y: Math.random() * H, r: Math.random() * 1.6 + .3, s: Math.random() * .25 + .05, a: Math.random() * Math.PI * 2, t: Math.random() * .02 + .004 });
      }
      function tick() {
        if (!running) return;
        ctx.clearRect(0, 0, W, H);
        for (var i = 0; i < parts.length; i++) {
          var p = parts[i]; p.y -= p.s; p.a += p.t; p.x += Math.sin(p.a) * .15;
          if (p.y < -5) { p.y = H + 5; p.x = Math.random() * W; }
          var o = .35 + Math.sin(p.a * 2) * .3;
          ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(228,207,159,' + Math.max(o, .05) + ')'; ctx.shadowBlur = 8; ctx.shadowColor = 'rgba(228,207,159,.8)'; ctx.fill();
        }
        requestAnimationFrame(tick);
      }
      size(); tick();
      window.addEventListener('resize', size);
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { var was = running; running = e[0].isIntersecting; if (running && !was) tick(); }).observe(canvas);
    });

    /* ---- Hero parallax (mouse) ---- */
    var stage = document.querySelector('[data-wi-stage]');
    if (stage && !reduce && window.matchMedia('(hover: hover)').matches) {
      var layers = stage.querySelectorAll('[data-depth]');
      window.addEventListener('mousemove', function (e) {
        var x = (e.clientX / window.innerWidth - .5), y = (e.clientY / window.innerHeight - .5);
        layers.forEach(function (l) { var d = parseFloat(l.getAttribute('data-depth')); l.style.translate = (x * d) + 'px ' + (y * d) + 'px'; });
      });
    }

    /* ---- Videos: play only when visible ---- */
    document.querySelectorAll('video[data-wi-autoplay]').forEach(function (v) {
      v.muted = true;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { if (e[0].isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }, { threshold: .2 }).observe(v);
      }
    });

    /* ---- Reviews carousel ---- */
    document.querySelectorAll('[data-wi-reviews]').forEach(function (root) {
      var slides = root.querySelectorAll('.wi-review'), dots = root.querySelector('.wi-dots'), i = 0, timer;
      if (!slides.length) return;
      slides.forEach(function (_, k) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Show review ' + (k + 1)); b.addEventListener('click', function () { go(k); restart(); }); dots && dots.appendChild(b); });
      function go(n) { i = (n + slides.length) % slides.length; slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); }); if (dots) [].forEach.call(dots.children, function (d, k) { d.classList.toggle('is-active', k === i); }); }
      function restart() { clearInterval(timer); if (!reduce) timer = setInterval(function () { go(i + 1); }, 7000); }
      var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
      prev && prev.addEventListener('click', function () { go(i - 1); restart(); });
      next && next.addEventListener('click', function () { go(i + 1); restart(); });
      go(0); restart();
    });

    /* ---- Accordion smooth height ---- */
    document.querySelectorAll('.wi-acc details').forEach(function (d) {
      var s = d.querySelector('summary'), body = d.querySelector('.wi-acc__body');
      if (!s || !body || reduce) return;
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) {
          body.animate([{ height: body.offsetHeight + 'px' }, { height: '0px' }], { duration: 450, easing: 'cubic-bezier(.22,.8,.2,1)' }).onfinish = function () { d.open = false; };
        } else {
          var group = d.closest('.wi-acc'); if (group) group.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
          d.open = true; var h = body.offsetHeight;
          body.animate([{ height: '0px' }, { height: h + 'px' }], { duration: 550, easing: 'cubic-bezier(.22,.8,.2,1)' });
        }
      });
    });
  });
})();

/* WeddingInvites.pk — remember where the visitor came from (ad / campaign) for the Buy page,
   and turn the homepage cards' "Buy Now" into "Show details" → that design's landing page
   (same as the All designs page). */
(function () {
  try {
    var q = new URLSearchParams(location.search), out = [];
    ['utm_source', 'utm_campaign', 'utm_content'].forEach(function (k) { if (q.get(k)) out.push(k.replace('utm_', '') + ': ' + q.get(k)); });
    if (q.get('fbclid')) out.push('Meta ad click');
    if (out.length && !sessionStorage.getItem('wi_src')) sessionStorage.setItem('wi_src', out.join(' · '));
  } catch (e) {}

  function relabel() {
    document.querySelectorAll('[data-product-url] [data-modal-trigger]').forEach(function (b) {
      if (b.__wiDetails) return; b.__wiDetails = 1;
      b.textContent = 'Show details';
      b.setAttribute('aria-label', 'Show details: ' + (b.closest('[data-product-url]').dataset.productName || ''));
    });
  }
  relabel();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', relabel);

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-modal-trigger]');
    var card = b && b.closest('[data-product-url]');
    if (!card) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var url = card.dataset.productUrl + '?view=landing';
    if (e.metaKey || e.ctrlKey) window.open(url, '_blank'); else location.href = url;
  }, true);
})();

/* WeddingInvites.pk — design tiles: tapping any empty part of a tile opens that design's landing page
   (buttons and the image keep their own links). Homepage collection + All designs page. */
(function () {
  var st = document.createElement('style');
  st.textContent = '#pricing [data-product-url], .wd-card { cursor: pointer; }';
  document.head.appendChild(st);
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    /* homepage cards: the name / description / price sit inside the image's preview link; send those taps to the landing page too */
    var home = e.target.closest('#pricing [data-product-url]');
    var textTap = home && e.target.closest('[class^="ai-wedding-templates-card-image-link-"]') && !e.target.closest('[class^="ai-wedding-templates-card-image-wrapper-"]');
    if (!textTap && e.target.closest('a, button, input, select, textarea, label, [data-modal-trigger]')) return;
    if (textTap) e.preventDefault();
    var url = '';
    var wd = e.target.closest('.wd-card');
    if (wd) { var l = wd.querySelector('.wd-btn--ink'); url = l && l.getAttribute('href'); }
    else {
      var card = e.target.closest('#pricing [data-product-url]');
      if (card) url = card.dataset.productUrl + '?view=landing';
    }
    if (!url) return;
    if (e.metaKey || e.ctrlKey || e.button === 1) window.open(url, '_blank');
    else location.href = url;
  });
})();
